import { Wrapper, ContentTypeRender } from "nystem-components";

const TextSlug = ({ model, path, setValue, view }) => {
  const { className, renderAs, item } = model;

  function convertToUrl(text) {
    return text
      .toString() // Ensure input is a string
      .normalize("NFD") // Separate base letters from accents
      .replace(/[\u0300-\u036f]/g, "") // Remove the accent marks
      .toLowerCase() // Make lowercase
      .trim() // Remove leading/trailing spaces
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^\w-]+/g, "") // Remove remaining non-word characters
      .replace(/--+/g, "-"); // Remove duplicate hyphens
  }

  const insertVal = (val) => {
    if (!val) return val;

    return val.replace(/\{([a-z_.0-9]+)\}/gim, (str, p1) => {
      if (p1 === "id") return view.id;

      if (p1.indexOf("params.") === 0)
        return view.params[p1.replace("params.", "")];

      if (p1.indexOf("baseView.") !== 0)
        return view.getValue(p1.replace("..", path));

      p1 = p1.replace("baseView.", "");
      return view.baseView.getValue(p1.replace("..", path));
    });
  };

  return (
    <Wrapper
      className={className}
      renderAs={renderAs}
      onClick={() => setValue(convertToUrl(insertVal(model.insertVal)))}
    >
      <ContentTypeRender path={path} items={item} />
    </Wrapper>
  );
};

export default TextSlug;
